<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const authStore = useAuthStore()
const router = useRouter()

const code = ref('')
const error = ref('')
const loading = ref(false)

async function submitCode() {
  if (!code.value.trim()) {
    error.value = 'Please enter an invite code'
    return
  }

  loading.value = true
  error.value = ''

  try {
    const success = await authStore.redeemInvite(code.value.trim().toUpperCase())
    if (success) {
      router.push('/')
    } else {
      error.value = 'Invalid or expired invite code'
    }
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to redeem code'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800 p-4">
    <div class="card max-w-md w-full">
      <div class="text-center mb-6">
        <div class="text-5xl mb-4">🎟️</div>
        <h1 class="text-2xl font-bold text-gray-800">Enter Invite Code</h1>
        <p class="text-gray-600 mt-2">
          Welcome, {{ authStore.user?.name }}! Enter your invite code to activate your account.
        </p>
      </div>

      <form @submit.prevent="submitCode" class="space-y-4">
        <div>
          <label for="code" class="form-label">Invite Code</label>
          <input
            id="code"
            v-model="code"
            type="text"
            placeholder="XXXXXX"
            class="form-input text-center text-2xl tracking-widest uppercase"
            maxlength="6"
            :disabled="loading"
          />
        </div>

        <p v-if="error" class="text-red-500 text-sm text-center">{{ error }}</p>

        <button
          type="submit"
          class="btn btn-primary w-full"
          :disabled="loading"
        >
          {{ loading ? 'Verifying...' : 'Activate Account' }}
        </button>
      </form>

      <div class="mt-6 text-center">
        <button
          @click="authStore.logout"
          class="text-sm text-gray-500 hover:text-gray-700"
        >
          Sign out and use a different account
        </button>
      </div>
    </div>
  </div>
</template>
